import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {Panel} from './panel';
import settings from './settings';
import {ri} from './runner-idle';

@customElement('ri-dev-tools')
export class DevTools extends Panel {
  override name = 'Settings';
  override id = 'dev';
  override connectedCallback() {
    super.connectedCallback();
    this.classList.add('dev');
  }
  override setup() {
    super.setup();
    this.settings = ri.settings;
    this.toggleSettings(true);
  }

  override render() {
    return super.render(html` <button
        @click=${() => {
          window.open(
            'https://www.youtube.com/embed/dQw4w9WgXcQ?rel=0&autoplay=1',
            undefined,
            'popup'
          );
        }}
      >
        Don't click
      </button>
      <button
        @click=${() => {
          settings();
        }}
      >
        Pause Menu (ESC)
      </button>`);
  }
}
